module.exports = AMap;


//////////////////
// WEBPACK FOOTER
// external "AMap"
// module id = +aT9
// module chunks = 14